import { PageId } from 'constants/pages'

export const enum PageIdWoofzEsa {
  INTRO_ESA = PageId.INTRO_ESA,
  MOTIVATION_ESA = PageId.MOTIVATION_ESA,
  YOUR_AGE_ESA = PageId.YOUR_AGE_ESA,
  ESA_LETTER = PageId.ESA_LETTER,
  ACCOMPANY_ESA = PageId.ACCOMPANY_ESA,
  HAPPINESS_ESA = PageId.HAPPINESS_ESA,
  SADNESS_ESA = PageId.SADNESS_ESA,
  TRY_ESA = PageId.TRY_ESA,
  FULL_SUPPORT_ESA = PageId.FULL_SUPPORT_ESA,
  EXPERT_ESA = PageId.EXPERT_ESA,
  PERSONALIZED_ESA = PageId.PERSONALIZED_ESA,
  MENTAL_HEALTH_ESA = PageId.MENTAL_HEALTH_ESA,
  SADNESS_LAST_WEEKS_ESA = PageId.SADNESS_LAST_WEEKS_ESA,
  ANGER_LAST_WEEKS_ESA = PageId.ANGER_LAST_WEEKS_ESA,
  WORRY_LAST_WEEKS_ESA = PageId.WORRY_LAST_WEEKS_ESA,
  AFRAID_LAST_WEEKS_ESA = PageId.AFRAID_LAST_WEEKS_ESA,
  SLEEP_LAST_WEEKS_ESA = PageId.SLEEP_LAST_WEEKS_ESA,
  NERVOUS_LAST_WEEKS_ESA = PageId.NERVOUS_LAST_WEEKS_ESA,
  MEMORY_LAST_WEEKS_ESA = PageId.MEMORY_LAST_WEEKS_ESA,
  FOCUS_ESA = PageId.FOCUS_ESA,
  EMOTIONAL_SCORE_ESA = PageId.EMOTIONAL_SCORE_ESA,
  DOG_NOTICE_UPSET_ESA = PageId.DOG_NOTICE_UPSET_ESA,
  DOG_NEXT_TO_YOU_ESA = PageId.DOG_NEXT_TO_YOU_ESA,
  DOG_SUPPORT_CUES_ESA = PageId.DOG_SUPPORT_CUES_ESA,
  STATS_ESA = PageId.STATS_ESA,
  DOG_BREED_ESA = PageId.DOG_BREED_ESA,
  DOG_AGE_ESA = PageId.DOG_AGE_ESA,
  DOG_SIZE_ESA = PageId.DOG_SIZE_ESA,
  URGE_ESA = PageId.URGE_ESA,
  PREPARE_FLOW_ESA = PageId.PREPARE_FLOW_ESA,
  PLAN_ESA = PageId.PLAN_ESA,
  EMAIL_ESA = PageId.EMAIL_ESA,
  SUBSCRIPTIONS_ESA = PageId.SUBSCRIPTIONS_ESA,
  CANCEL_OFFER_ESA = PageId.CANCEL_OFFER_ESA,
  CHAT_UPSELL_ESA = PageId.CHAT_UPSELL_ESA,
  UPSELL_ESA = PageId.UPSELL_ESA,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_ESA = PageId.DOWNLOAD_ESA,
}
